import { createSlice } from "@reduxjs/toolkit";
import ApiClientConnector from "src/api/ApiClientConnector";

const initialState = {
    locationList: [],
    isLocationViewChanged: false,
    selectedLocation: null,
};

export const LocationManagerSlice = createSlice({
    name: 'locations',
    initialState,
    reducers: {
        getLocationList: (state, action) => {
            state.locationList = action.payload;
        },
        manageLocationView: (state, action) => {
            state.isLocationViewChanged = action.payload;
        },
        setSelectedLocation: (state, action) => {
            state.selectedLocation = action.payload;
        },
        updateLocationStatusInList: (state, action) => {
            const { locationId, status } = action.payload;
            const locationIndex = state.locationList.findIndex((location) => location.Id === locationId);
            if (locationIndex !== -1) {
                state.locationList[locationIndex].State = status;
            }
            if (state.selectedLocation?.Id === locationId) {
                state.selectedLocation = {
                    ...state.selectedLocation,
                    State: status,
                };
            }
        },

    }
})

export const { getLocationList, manageLocationView, setSelectedLocation, updateLocationStatusInList } = LocationManagerSlice.actions;

export const fetchLocations = (instance, accounts, criteria) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.locations.get(criteria);
    dispatch(getLocationList(result));
    return result;
}

export const fetchLocationsDistance = (instance, accounts, requestItems) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.locations.getDistance({ Requests: requestItems });
    return result;
}

export const updateLocationStatus = (instance, accounts, locationId, payload) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const response = await client.locations.updateLocationStatus(locationId, payload);
    dispatch(updateLocationStatusInList({ locationId, status: response?.State }));
    return response;
}

export default LocationManagerSlice.reducer;